import { LocationNumbersService } from '../../../services'

const fetchPhoneNumbersA2PStatus = async function (
  { commit, state, getters },
  config
) {
  const { companyId, locationId } = config
  try {
    const { data } = await LocationNumbersService.getA2PStatus(companyId, locationId)

    commit('setPhoneNumbersA2PLookup', data)

    const result = data?.linkedNumbers
    return Promise.resolve(result)
  } catch (error) {
    return Promise.reject(error)
  }

}

export default fetchPhoneNumbersA2PStatus
